export default __webpack_public_path__ + "static/smh_logo_white-c3ae31951fbbc7eded2bfae84002500b.png";